<!--
 * @Author: xiaokun
 * @Date: 2020-04-11 16:39:44
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-06-12 11:34:24
 * @Description: 右侧 话术库表格
 -->
<template>
  <div class="question-table">
    <div class="question-table-list-biz">
      <list-biz
        ref="questionTableListBiz"
        :choose-list="chooseQuestionList"
        class="question-biz__table"
        :config="config"
        :data="data"
        :total="total"
        :page="page"
        hide-selection
        @on-current-change="handleOnCurrentChange"
        @on-select-change="handleOnSelectChange"
      >
        <!-- @on-search-change="hanldeOnSearchClick"
      @on-type-change="handleOnTypeChange"
      -->
        <ds-search
          slot="search"
          :form-schema="formSchema"
          @on-search-click="handleOnSearchClick"
          @on-reset-click="handleOnResetClick"
        />
      </list-biz>
    </div>
    <div class="question-table-bottom-handle">
      <div class="question-table-select-tips">
        已选中<span>{{ curSelectQuestionList.length }}</span>个资料
      </div>
      <div class="question-table-bottom-handle-op">
        <mk-button-biz
          width="64px"
          height="32px"
          font-size="13px"
          @click="cancelGuideQuestion"
        >
          取消
        </mk-button-biz>
        <mk-button-biz
          class="confirm"
          type="primary"
          width="64px"
          height="32px"
          font-size="13px"
          @click="confirmGuideQuestion"
        >
          导入
        </mk-button-biz>
      </div>
    </div>
  </div>
</template>
<script>
import List from './questions-table-components/index.js'
import selectCommodityTags from './search-components/commodity-tags.vue'
import selectKeyWords from './search-components/key-words.vue'
import selectFocusInput from './search-components/focus-input.vue'
import { mapState } from 'vuex'
export default {
  name: 'QuestionTable',
  components: {},
  props: {
    chooseQuestionList: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      // 表单配置数据
      config: {
        selectAll: false,
        // 列表模式
        mode: 'table',
        name: 'ExaminationManage',
        // 列表配置
        list: List
      },
      formSchema: {
        title: {
          type: 'string',
          value: '',
          defaultValue: '',
          label: '',
          width: '240',
          placeholder: '请输入问题名称',
          ui: {
            widget: 'MkInput', // 组件名
            widgetConfig: {} // 组件配置
          }
        },
        // 关键词
        keyWords: {
          type: 'Array',
          value: [],
          defaultValue: [],
          width: '200',
          ui: {
            widget: selectKeyWords, // 组件名
            widgetConfig: {
              tip: false
            } // 组件配置
          }
        },
        // 商品标签
        commodityTags: {
          type: 'Array',
          value: [],
          defaultValue: [],
          width: '200',
          ui: {
            widget: selectCommodityTags, // 组件名
            widgetConfig: {
            } // 组件配置
          }
        }
      },
      // 表单数据
      data: [],
      // 查询参数
      params: {},
      // 当前页
      page: 1,
      // 总数
      total: 1,
      // 面包屑导航
      crumbData: [],
      // 当前搜索的菜单的id
      // currentMenuId: 'const-question-tree-root-id',
      // 搜索条件
      // searchCondition: {
      //   commodityTags: [],
      //   keyWords: [],
      //   title: ''
      // },
      // 当前导入时选中数据
      curSelectQuestionList: []
    }
  },
  computed: {
    // 树形结构当前id
    currentMenuId () {
      return this.$store.state['examination-manage'].currentMenuId
    }
  },
  watch: {},
  created () {
    // 初始化获取 右侧问题数据
    this.initParams()
  },
  mounted () {
  },
  methods: {
    initParams () {
      // 每次切换 树形菜单 翻页 清空选中数组，为了清空底部所选条数
      this.curSelectQuestionList = []
      this.params = {
        page: this.page,
        pageSize: 10,
        parent: this.currentMenuId,
        title: this.formSchema.title.value,
        keyWords: this.formSchema.keyWords.value,
        commodityTags: this.formSchema.commodityTags.value
      }
      this.pQuestionShowPost()
    },
    // 获取数据
    async pQuestionShowPost () {
      let res = await CONVERSATIONAPIS.QuestionsApi.pQuestionShowPost(this.params)
      if (res.success) {
        let { data, total, page } = res.data
        this.data = data
        this.page = page
        this.total = total
      } else {
        this.$error.error('查询失败')
      }
    },
    // 搜索
    handleOnSearchClick (params) {
      this.page = 1
      this.initParams()
    },
    // 重置
    handleOnResetClick (params) {
      this.formSchema.commodityTags.value = []
      this.formSchema.title.value = ''
      this.formSchema.keyWords.value = []
      this.page = 1
      this.initParams()
    },
    // 表格勾选事件
    handleOnSelectChange (val) {
      // 复制当前选中数据
      this.curSelectQuestionList = val
    },
    // 翻页事件
    handleOnCurrentChange (value) {
      this.page = value
      // 获取数据
      this.initParams()
    },
    // 取消导入
    cancelGuideQuestion () {
      this.curSelectQuestionList = []
      this.$emit('on-drawer-close-click')
    },
    // 确认导入
    confirmGuideQuestion () {
      this.$emit('on-select-question', this.curSelectQuestionList)
      // 提交至父级后 清空选中数组
      // this.curSelectQuestionList = []
    },
    // 清除所选
    clearSelection () {
      this.curSelectQuestionList = []
      this.$refs.questionTableListBiz.clearSelection()
    }
  }
}
</script>
<style lang="scss" scoped>
.question-table {
  height: calc(100vh - 152px);
  position: relative;

  .question-table-list-biz {
    height: 100%;
    padding: 20px 20px 0;
  }

  .question-table-bottom-handle {
    margin-top: 15px;
    padding: 12px 20px;
    box-shadow: 0 -2px 4px 0 rgba(5, 49, 38, 0.05);
    display: flex;
    align-items: center;
    justify-content: space-between;

    .question-table-select-tips {
      color: #595959;
      font-size: 13px;

      span {
        color: #009cff;
        display: inline-block;
        padding: 0 5px;
        font-size: 16px;
      }
    }
  }
}
</style>
